export default __webpack_public_path__ + "static/FGASA-4774ab3b9be538385a1b7d308d40637d.svg";